import React, { useEffect } from 'react'
import { FlagProvider, useUnleashContext } from '@unleash/proxy-client-react'
import { usePlace } from './usePlace'

const config = {
  url: process.env.REACT_APP_UNLEASH_URL,
  clientKey: process.env.REACT_APP_UNLEASH_CLIENT_KEY,
  refreshInterval: 2 * 60,
  appName: process.env.REACT_APP_UNLEACH_APP_NAME,
}

export const UnleashCurrentContext = React.createContext()

export const UnleashProvider = ({ children }) => {
  const [currentContext, setCurrentContext] = React.useState({
    placeId: undefined,
  })
  return (
    <UnleashCurrentContext.Provider
      value={{ currentContext, setCurrentContext }}
    >
      <FlagProvider config={config}>{children}</FlagProvider>
    </UnleashCurrentContext.Provider>
  )
}

export function useUnleash() {
  const { setCurrentContext } = React.useContext(UnleashCurrentContext)
  const place = usePlace()
  const placeId = place ? place.id : undefined
  const updateContext = useUnleashContext()
  useEffect(() => {
    async function run() {
      if (placeId == null) return
      await updateContext({ placeId })
      setCurrentContext((current) => ({ ...current, placeId }))
    }
    run()
  }, [placeId, setCurrentContext])
}
